import type { SxProps, Theme } from "@mui/material";
import { Stack } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  showBorder?: boolean;
  sx?: SxProps<Theme>;
}

export const StyleItem = ({ showBorder, sx, children }: PropsWithChildren<Props>) => {
  return (
    <Stack
      sx={{
        borderBottom: showBorder ? "1px dashed" : "none",
        borderBottomColor: showBorder ? "divider" : undefined,
        pb: 1,
        gap: 0.5,
        width: "100%",
        ...sx,
      }}
    >
      {children}
    </Stack>
  );
};

export default StyleItem;
